import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, } from '@angular/forms';
import { Observable } from 'rxjs';
import { Customer } from '../../../@core/models/Customer';
import { map, startWith } from 'rxjs/operators';
import { SectorService } from '../../../@core/services/sector.service';
import { RouteCompress } from '../../../@core/models/live-route';
import { StopService } from '../../../@core/services/stop.service';
import { ApiProvider } from '../../../@core/providers/api.provider';
import { SpinnerService } from '../../../@core/services/SpinnerService';
import { MatDialog } from '@angular/material';
import { TextDialogComponent } from '../text-dialog/text-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'create-pickup',
  templateUrl: './create-pickup.component.html',
  styleUrls: ['./create-pickup.component.scss']
})
export class CreatePickupComponent implements OnInit {

  public customerId : FormControl;
  public routeId : FormControl;



  public customers: Customer[] = [];
  public routes: RouteCompress[] = [];

  public routeDefaultValue  = "53001"
  public message            = "";
  public ionDatelivString   : string;

  customerOptions : Observable<Customer[]>;
  routeOptions    : Observable<RouteCompress[]>;


  constructor(
    private datePipe: DatePipe,
    private sectorService: SectorService,
    private stopService : StopService,
    public apiProvider: ApiProvider,
    public spinnerService: SpinnerService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private toastservice : ToastrService
  ) {
      this.customerId =  new FormControl('');
      this.routeId = new FormControl('');
  
   }

  ngOnInit() {
    
    this.spinnerService.showSpinner();
    this.apiProvider.getCustomers().subscribe(
      (customers : any) => {
        for(let customer of customers){
          let cust = new Customer();
          cust.CustomerID = customer.CustomerID;
          cust.Name = customer.Name;
          this.customers.push(cust);
        }

        this.customerOptions = this.customerId.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value.name),
          map(name => name ? this._filter(name) : this.customers.slice())
        );

        this.spinnerService.stopSpinner();

      },
      (err) => {

        this.spinnerService.stopSpinner();
        this.dialog.open(TextDialogComponent, { data : { text: "Impossible de charger les données veuillez réessayer ultérieurement." } } );
        
      }
    )

    this.sectorService.currentSector.subscribe(
      (sector) => {
        this.routes = sector.RouteCompress

        for(let route of sector.RouteCompress){
          if(this.stopService.RouteID == route.Route_ID){
            this.routeId.setValue(route);
          }
        }
        this.routeOptions = this.routeId.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value.Route_ID.toString()),
          map(name => name ? this._routeFilter(name) : this.routes.slice())
        );

      }
    );

    this.ionDatelivString = this.datePipe.transform(
      new Date(),
      'yyyy-MM-ddTHH:mm'
    );

  }

  public displayFn(user?: Customer): string | undefined {
    return user ? user.Name : undefined;
  }

  displayRouteFn(route?: any): string | undefined {
    return route ? route.Route_ID.toString() : undefined;
  }

  private _filter(name: string): Customer[] {
    
    const filterValue = name.toLowerCase();

    return this.customers.filter(option => option.Name.toLowerCase().indexOf(filterValue) === 0);
  }

  private _routeFilter(name: string): RouteCompress[] {
    const filterValue = name.toLowerCase();

    return this.routes.filter(option => option.Route_ID.toString().toLowerCase().indexOf(filterValue) === 0);
  }

  submit(){
    let time = this.datePipe.transform(
      this.ionDatelivString,
      'HH:mm'
    );

    this.message = "";

    if(typeof this.customerId.value == "object" && typeof this.routeId.value == "object" && this.ionDatelivString){
      this.apiProvider.postPickup(this.routeId.value.Route_ID, this.customerId.value.CustomerID,this.ionDatelivString, time).subscribe(
        (data) => {
          this.toastservice.success(this.translate.instant('add-pickup-modal.success'));
          this.stopService.GetDataFromDataBase();
          this.dialog.closeAll();

        },
        (error) => {
          console.error(error);
          this.toastservice.error(this.translate.instant('add-pickup-modal.error'));
        }
      )
    }else{
      this.message = this.translate.instant('add-pickup-modal.form-error');
    }
  }


  cancel(){
    this.dialog.closeAll();
  }
}
